const windowKey = 'adobeDataLayer';

interface AdobeAppEvent {
    event: string;
    [key: string]: unknown;
}

export class AdobeAppEventDataSdk {
    static instance: AdobeAppEventDataSdk = new this();

    constructor() {
        return (<typeof AdobeAppEventDataSdk>this.constructor).instance;
    }

    trackEvent(event: AdobeAppEvent) {
        this.appEventData.push(event);
    }

    get computedState() {
        return this.appEventData.computedState;
    }

    private get appEventData() {
        if (!window[windowKey]) {
            window[windowKey] = [];
        }
        return window[windowKey];
    }
}
